<template>
    <div class="main-page">
        <div class="container container-poromo">
            <div class="promo-container">
                <div class="promo-pic">
                    <img :src="images.main" alt="">
                </div>
                <div class="lang">
                    <li><a href="#" @click.prevent="changeLand('ru')">РУС</a></li>
                    <li><a href="#" @click.prevent="changeLand('kz')">КАЗ</a></li>
                </div>
                <div class="promo-desc">
                    <div class="desc">
                        <img :src="images.warning" alt="" class="warning-icon">
                        <h1>{{promo_json.pageTitle}}</h1>
                        <div class="adres">
                            <img :src="images.marker" alt="">
                            <p>{{promo_json.adres}}</p>
                        </div>
                    </div>
                    <div class="import-desc">
                        <strong>{{promo_json.importDesc}}</strong>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-page form-top">
            <div class="container">
                <div class="form-title">
                    <img :src="images.check" alt="">
                    <h2>{{promo_json.formTitle.title}}</h2>
                    <p>{{promo_json.formTitle.desc}}</p>
                </div>
                <formFields :options="promo_json"></formFields>
            </div>
        </div>
        <div class="promo-items">
            <div class="item" v-for="(item, index) in promo_json.vacancy">
                <div class="container">
                    <div class="top-info">
                        <div class="title">
                            <!-- <div class="title-icon">
                                <img :src="images.icon_one" alt="" v-if="index == 0">
                                <img :src="images.icon_two" alt="" v-else>
                            </div> -->
                            <!-- <div class="count"><span>{{index + 1}}</span></div> -->
                            <h2>{{item.title}}</h2>
                            <p v-if="item.desc != null">{{item.desc}}</p>
                        </div>
                        <div class="phone">
                            <img :src="images.phone" alt="">
                            <span>{{promo_json.phone_title}}</span>
                            <div class="phones">
                                <a :href="'tel:' + number" v-for="number in item.phone">{{number}}</a>
                            </div>
                        </div>
                    </div>
                    <div class="vac-list" v-if="item.vac_list != null">
                        <ul>
                            <li v-for="vac in item.vac_list">
                                <img :src="images.check" alt="">
                                <p>{{vac}}</p>
                            </li>
                        </ul>
                    </div>
                    <div class="vac-desc" v-if="index == 0">
                        <div class="col-left">
                            <h3>{{promo_json.vacancyTitle_uslov}}</h3>
                            <div class="list">
                                <ul>
                                    <li v-for="list in promo_json.vacancy_info.info">{{list}}</li>
                                </ul>
                            </div>
                        </div>
                        <!-- <div class="col-right">
                            <h3>{{promo_json.vacancyTitle_treb}}</h3>
                            <div class="list">
                                <ul>
                                    <li v-for="list in promo_json.vacancy_info.import_desc">{{list}}</li>
                                </ul>
                            </div>
                        </div> -->
                    </div>
                    <a href="#" class="get-form" v-if="index == 0" v-scroll-to="{
                                el: '.footer-elem',
                                offset: 0
                        }">
                        <img :src="images.msg" alt="">
                        <p>{{promo_json.formBtn}}</p>
                    </a>
                </div>
            </div>
        </div>
        <div class="form-page form-bottom">
            <div class="container">
                <div class="form-title">
                    <img :src="images.check" alt="">
                    <h2>{{promo_json.formTitle.title}}</h2>
                    <p>{{promo_json.formTitle.desc}}</p>
                </div>
                <formFields :options="promo_json"></formFields>
            </div>
        </div>
        <div class="footer-elem">
            <div class="container"></div>
        </div>
    </div>
</template>

<script>
    import formFields from '@/components/forms/form'
    export default {
        name: 'main--page',
        components: {
            formFields
            // indexPromo,
        },
        data () {
            return {
                promo_json: null,
                images: {
                    main: 'https://v-web.kz/cms/media/shutterstock_1896787564-1.jpg',
                    punktir: 'https://v-web.kz/cms/media/union_2.svg',
                    marker: 'https://v-web.kz/cms/media/path_9.svg',
                    arrow: 'https://v-web.kz/cms/media/arrow.svg',
                    phone: 'https://v-web.kz/cms/media/union_5_1-03.svg',
                    warning: 'https://v-web.kz/cms/media/union_1.svg',
                    msg: 'https://v-web.kz/cms/media/group_19.svg',
                    check: 'https://v-web.kz/cms/media/2-layers-1.svg',
                    icon_one: 'https://v-web.kz/cms/media/1_ico.svg',
                    icon_two:'https://v-web.kz/cms/media/2_ico.svg',
                },
                ru: {
                    formParams: {
                        name: 'ФИО',
                        city: 'ГОРОД',
                        msg: 'Спасибо ваша заявка отправлена',
                        btn: 'отправить заявку',
                    },
                    pageTitle: 'На строительство объектов',
                    adres: 'в городе Алматы',
                    importDesc: 'СРОЧНО ТРЕБУЮТСЯ Бригады монолитчиков',
                    formTitle: {
                        title: 'Готовы к работе?',
                        desc: 'Заполните форму и мы свяжемся с вами'
                    },
                    formBtn: 'ОСТАВИТЬ ЗАЯВКУ',
                    phone_title: 'ПО ВСЕМ ВОПРОСАМ ЗВОНИТЕ ПО ТЕЛЕФОНУ:',
                    vacancyTitle_uslov: 'УСЛОВИЯ:',
                    vacancyTitle_treb: 'ОБЯЗАТЕЛЬНЫЕ ТРЕБОВАНИЯ:',
                    vacancy: [
                        {
                            title: 'ПРОФЕССИОНАЛЬНЫЕ БРИГАДЫ И ОРГАНИЗАЦИИ для выполнения монолитных работ',
                            desc: null,
                            phone: ['+7 747 095 15 59'],
                            vac_list: null,
                            // vac_list: [
                            //     'Оплата – 80 000 тг за м3',
                            //     'Мобилизация - в течение 3-5 дней',
                            //     'Питание и проживание оплачивается отдельно',
                            // ],
                        },
                        // {
                        //     title: 'БРИГАДЫ ОТ 25 ЧЕЛОВЕК С ОПЫТОМ РАБОТЫ В МОНОЛИТНОМ СТРОИТЕЛЬСТВЕ',
                        //     desc: null,
                        //     phone: ['+7 700 836 87 12'],
                        //     vac_list: null,
                        // },
                    ],
                    vacancy_info: {
                        info: [
                            '40 000 тг за м3',
                            'Большие объемы',
                            'Заработная плата от 450 000 тг и выше',
                        ],
                        // import_desc: [
                        //     'Наличие удостоверения/загранпаспорта со сроком не менее 1 года до окончания действия',
                        //     'Наличие паспорта вакцинации',
                        // ],
                    },
                },
                kz: {
                    formParams: {
                        name: 'Тегі Аты Әкесінің аты',
                        city: 'қала',
                        msg: 'Рахмет, сіздің өтінішіңіз жіберілді',
                        btn: 'Жіберу',
                    },
                    pageTitle: 'Объектілерді салуға тұрақты жұмысқа ',
                    adres: 'Алматы қаласында',
                    importDesc: 'Монолитшілер  бригадасы ШҰҒЫЛ ҚАЖЕТ',
                    formTitle: {
                        title: 'ЖҰМЫСҚА ДАЙЫНСЫЗ БА?',
                        desc: 'ӨТІНІМДІ ТОЛТЫРЫҢЫЗ, БІЗ СІЗБЕН ХАБАРЛАСАМЫЗ'
                    },
                    formBtn: 'ӨТІНІМДІ ЖІБЕРУ',
                    phone_title: 'БАРЛЫҚ СҰРАҚТАР БОЙЫНША ҚОҢЫРАУ ШАЛЫҢЫЗ:',
                    vacancyTitle_uslov: 'Шарттар:',
                    vacancyTitle_treb: 'МІНДЕТТІ ТАЛАПТАР:',
                    vacancy: [
                        {
                            title: 'Монолитті құрылыста тәжірибесі бар бригадалар мен компаниялар',
                            desc: null,
                            phone: ['+7 747 095 15 59'],
                            vac_list: null,
                        },
                        // {
                        //     title: 'ТҰТАСҚҰЙМА ҚҰРЫЛЫСЫНДА ЖҰМЫС ТӘЖІРИБЕСІ БАР 25 АДАМНАН ТҰРАТЫН БРИГАДАЛАР КЕРЕК',
                        //     desc: null,
                        //     phone: ['+7 700 836 87 12'],
                        //     vac_list: null,
                        // },
                    ],
                    vacancy_info: {
                        info: [
                            'Төлем - м3 үшін 40 000 тг',
                            'Көлемдері үлкен',
                            '450 000 теңгеден жоғары жалақы',
                        ],
                        // import_desc: [
                        //     'Қолданылу мерзімі аяқталғанға дейін кемінде 1 жыл мерзімі бар куәліктің/шетел төлқұжатының болуы',
                        //     'Вакциналау төлқұжатының болуы',
                        // ],
                    },
                }
                // title: 'Главная',
            }
        },
        computed: {
        },
        methods: {
            changeLand(param) {
                console.log(param)
                if (param == 'ru') {
                    this.promo_json = this.ru
                    document.body.dataset.lang = 'ru';
                } else {
                    this.promo_json = this.kz
                    document.body.dataset.lang = 'kz';
                }
            }
        },
        beforeCreate() {
        },
        created () {
            this.promo_json = this.ru
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/home/home-page-styles.scss';
    @import '@/styles/components/home/home-page-respond.scss';
</style>